import CardShell from './CardShell';

const ContainerBlue = ({ width, title, titleFallback, children, btns, label, headAction, className = '' }) => (
  <div className="mx-4">
    <CardShell
      variant="blue"
      width={width}
      title={title}
      titleFallback={titleFallback}
      label={label}
      headAction={headAction}
      btns={btns}
      className={className}
    >
      {children}
    </CardShell>
  </div>
);

export default ContainerBlue;
